import { persistReducer } from 'redux-persist';
import { BUILD_TARGET } from "../../config";
const isClient = BUILD_TARGET === 'client';
/**
 * Redux persister helper
 */

class PersistHelper {}

PersistHelper.storage = null;

PersistHelper.persist = (config, reducer, disable = false) => {
  if (disable || !isClient) {
    return reducer;
  }

  if (!config.storage) {
    if (PersistHelper.storage === null) {
      PersistHelper.storage = require('@kakadu-dev/base-frontend-helpers/storage/AsyncStorage').default;
    }

    config.storage = PersistHelper.storage;
  }

  return persistReducer(config, reducer);
};

export default PersistHelper;